import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export function QuestionsPage(): JSX.Element {
  const { contentId } = useParams();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    async function getData() {
      if (!contentId)  {
        return setLoading(false);
      }
      setLoading(true);
      // load the content
      setLoading(false);
    }
    getData();
  }, []);

  return (
  <></>
  );
}

